export default "__VITE_ASSET__CTeihZb1__"